import React from 'react';
import Download from 'components/download';
import constants from '../constants';

const ToolsDescriptionPage = () => (
  <div className="container">
    <div className="l-demo-content">
      <div className="tab-content-description">
        <div className="row justify-content-md-center">
          <div className="col-md-10">
            <div className="summary">
              <p>
                Avail of the application’s EU-wide traffic data to start assessing your local transport emissions policies now!
                  </p>
              <p>
                Atmo-plan is a user-friendly web application for assessing the impact of changing transport emissions on air quality, at a high spatial resolution.   Thanks to the integration of a precompiled database of traffic intensity estimates and the CAMS regional re-analysis dataset, traffic emission scenarios can be performed for any city across the EU-28.
                  </p>
              <p>
                Check how the application can support your local air quality policies, urban air quality plans and planning assessments. Evaluate Low Emission Zone options and get more from your own local transport network and fleet information!
                  </p>
              <p>Register now to test out the application for a trial period.</p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="characteristics-table">
              <div className="col-md-12">
                <div className="main-characteristics">
                  Main characteristics
                    </div>
              </div>
              <div className="row justify-content-md-center">
                <div className="col-md-12">
                  <div className="table-item">
                    <div className="row">
                      <div className="col-sm-12 col-md-4">
                        <div className="table-label">
                          Easy of use
                            </div>
                      </div>
                      <div className="col-sm-12 col-md-8">
                        <div className="table-value">
                          <div className="value-list">
                            Air quality modelling expertise is not necessary to use the software. No installation is required as the simulations are performed on our HPC computing infrastructure.
                              </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-item">
                    <div className="row">
                      <div className="col-sm-12 col-md-4">
                        <div className="table-label">
                          Key emission sectors
                            </div>
                      </div>
                      <div className="col-sm-12 col-md-8">
                        <div className="table-value">
                          Road transport and industrial, residential heating under development.
                            </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-item">
                    <div className="row">
                      <div className="col-sm-12 col-md-4">
                        <div className="table-label">
                          Air pollutants modelled
                            </div>
                      </div>
                      <div className="col-sm-12 col-md-8">
                        <div className="table-value">
                          NO2, PM2.5, PM10,  in units µg/m³.
                            </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-item">
                    <div className="row">
                      <div className="col-sm-12 col-md-4">
                        <div className="table-label">
                          Background concentrations included
                            </div>
                      </div>
                      <div className="col-sm-12 col-md-8">
                        <div className="table-value">
                          The Copernicus Atmosphere Monitoring Service (CAMS) EU regional ensemble re-analysis dataset for 2015.
                            </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-item">
                    <div className="row">
                      <div className="col-sm-12 col-md-4">
                        <div className="table-label">
                          Meteorological data included
                            </div>
                      </div>
                      <div className="col-sm-12 col-md-8">
                        <div className="table-value">
                          ECMWF ERA-5 dataset for 2015.
                            </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-item">
                    <div className="row">
                      <div className="col-sm-12 col-md-4">
                        <div className="table-label">
                          Traffic data included for every city in the EU
                            </div>
                      </div>
                      <div className="col-sm-12 col-md-8">
                        <div className="table-value">
                          A database of generic European wide traffic intensities has been generated using estimates for the number of vehicles on all European roads based on mileage data per country (COPERT 2014 dataset), a roadmap (OpenTransportMaps) and proxy data based on population data (JRC) and road typology (OpenStreetMaps).  The resulting database is used as input to the traffic emissions model which then generates the traffic emissions for each road segment.
                            </div>
                      </div>
                    </div>
                  </div>

                  <div className="table-item">
                    <div className="row">
                      <div className="col-sm-12 col-md-4">
                        <div className="table-label">
                          Viewer
                            </div>
                      </div>
                      <div className="col-md-8">
                        <div className="table-value">
                          <div className="value-list">
                            <ul>
                              <li>View annual mean and percentile values for each scenario.</li>
                              <li>View the difference (concentrations/relative difference) between each scenario within your case.</li>
                              <li>
                                View the traffic intensities  for each scenario simulation.
                                  </li>
                              <li>View  timeseries  of pre-selected receptor points</li>
                            </ul>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div className="table-item">
                    <div className="row">
                      <div className="col-sm-12 col-md-4">
                        <div className="table-label">
                          Key outputs
                            </div>
                      </div>
                      <div className="col-md-8">
                        <div className="table-value">
                          <div className="value-list">
                            <ul>
                              <li>Geotiff rasters for the annual mean and percentile values for each scenario.</li>
                              <li>Annual mean concentrations and percentiles for each receptor point.</li>
                              <li>
                                The time series for the points of interest for the pollutants PM10, PM2.5 and NO2 as a csv-file.
                                  </li>
                              <li>The traffic emission values on the line segments as a csv-file.</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-item">
                    <div className="row">
                      <div className="col-sm-12 col-md-4">
                        <div className="table-label">
                          Applications
                            </div>
                      </div>
                      <div className="col-md-8">
                        <div className="table-value">
                          <div className="value-list">
                            <ul>
                              <li>The software can be tailored for specific assessment processes e.g. environmental permit processes and/or environmental Impact Assessments (EIA).</li>
                              <li>Default data and emission mitigation options can be ‘predefined’ into the configuration.</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="row justify-content-md-center">
      <div className="col-md-10">
        <div className="download-buttons">
          <Download pdf={constants.atmo.factsheet} />
          <Download pdf={constants.atmo.manual} />
        </div>
      </div>
    </div>
  </div>
);

export default ToolsDescriptionPage;



// WEBPACK FOOTER //
// ./src/pages/products/tools/description.js